var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.genderRate && _vm.genderRate.count && _vm.genderRate.labels )?_c('div',{staticClass:"h-100"},[_c('PieChart',{attrs:{"data":_vm.genderRate.count,"labels":_vm.genderRate.labels}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }